/**
 * @file paddlex 用户信息hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useCallback, useRef} from 'react';
import {Form, message} from 'antd';
import {useHistory} from 'react-router-dom';

import {useVerifyCode} from '../../../../components/verify-code/verifyCodeHooks';
import {fetchSubmitUserInfo} from '../../../../api/pages/paddlexApi';
import messageSuccess from './components/message-success/messageSuccess';


const useUserInfoHooks = () => {
    const history = useHistory();

    const {
        verifyCodeImg,
        randomStr,
        verifyCodeLoading,

        getVerifyCode
    } = useVerifyCode();
    const [userInfoForm] = Form.useForm();
    const {setFields} = userInfoForm;

    const randomStrRef = useRef<string>(randomStr);
    randomStrRef.current = randomStr;

    const historyPush = history.push;
    const onFormSubmit = useCallback(
        async (values: any) => {
            const urlSearch = new URLSearchParams(window.location.search.slice(1));
            const res = await fetchSubmitUserInfo({
                centerUserType: values.centerUserType,
                developerCompany: values.developerCompany,
                developerLocationCity: values.developerLocationCity,
                developerLocationProvince: values.developerLocationProvince,
                developerPosition: values.developerPosition,
                email: values.email,
                industry: values.industry,
                mobile: values.mobile,
                nickname: values.nickname,
                otherUserType: values.otherUserType,
                scene: values.scene,
                username: values.username,
                verifyCode: values.verifyCode,
                randomStr: randomStrRef.current,
                source: urlSearch.get('source') || ''
            });
            if (res && res.body) {
                if (res.body?.errorCode === 0) {
                    messageSuccess({
                        content: '保存成功'
                    });
                    if (typeof (localStorage) === 'object') {
                        localStorage.setItem('paddlexuserinfosubmit', 'true');
                    }
                    setTimeout(() => {
                        const p = new URLSearchParams(window.location.search.slice(1));
                        const directdownload = p.get('directdownload');
                        historyPush(`/paddlex/download?${directdownload && 'directdownload=' + directdownload}`);
                        window.scrollTo(0, 0);
                    }, 1000);
                }
                else if (res.body.errorCode === 500 && res.body.errorMsg === '验证码错误') {
                    setFields([{
                        name: 'verifyCode',
                        errors: [res.body.errorMsg]
                    }]);
                    getVerifyCode();
                }
                else {
                    (window as any).DEBUG && message.error(res.body.errorMsg);
                    getVerifyCode();
                }
            }
        },
        [setFields, historyPush, getVerifyCode]
    );

    const historyGoBack = history.goBack;
    const onFormCancel = useCallback(() => {
        historyGoBack();
    }, [historyGoBack]);

    return {
        verifyCodeImg,
        randomStr,
        verifyCodeLoading,

        getVerifyCode,

        userInfoForm,

        onFormSubmit,
        onFormCancel
    };
};

export default useUserInfoHooks;
